import { LabMDM } from "./lab";
import { OperetionHistoryDTO } from "./operationHistory";

//this model is used to deinf e the lab properites
export class TagSystem{
    _id: string;
    tagSystemName: string;
    lab:LabMDM;
    tagExcelFileName:string;
    active:boolean;
    version: number;
    creationDate: Date;
    file:any;
    tagPlates:string[];
    history:OperetionHistoryDTO[];
}